import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import RangeInput from "components/common/RangeInput";
import { RISK_SCORE_RANGE } from "security-app/components/SecurityEvents/Alerts/Constants";
const RANGE_VALUE_SEPARATOR = "-";
const clampRiskScore = (value) => Math.min(RISK_SCORE_RANGE.max, Math.max(RISK_SCORE_RANGE.min, value));
const normalizeRangeValue = (value) => {
  const [first = RISK_SCORE_RANGE.min, second = first] = value;
  const min = clampRiskScore(Math.min(first, second));
  const max = clampRiskScore(Math.max(first, second));
  return [min, max];
};
const parseRiskScoreFilterValue = (value) => {
  if (!value) {
    return [RISK_SCORE_RANGE.min, RISK_SCORE_RANGE.max];
  }
  const [rawMin, rawMax] = value.split(RANGE_VALUE_SEPARATOR).map((v) => Number(v));
  const parsedMin = Number.isFinite(rawMin) ? rawMin : RISK_SCORE_RANGE.min;
  const parsedMax = Number.isFinite(rawMax) ? rawMax : RISK_SCORE_RANGE.max;
  return normalizeRangeValue([parsedMin, parsedMax]);
};
const formatRiskScoreFilterValue = ([min, max]) => `${min}${RANGE_VALUE_SEPARATOR}${max}`;
const RiskScoreFilterContent = ({ initialValue, onSubmit }) => {
  const { t } = useTranslation("enterprise_security_events");
  const [value, setValue] = useState(initialValue);
  const formattedValue = useMemo(() => formatRiskScoreFilterValue(value), [value]);
  const handleChange = useCallback((newValue) => {
    if (Array.isArray(newValue)) {
      setValue(normalizeRangeValue(newValue));
    }
  }, []);
  const handleAfterChange = useCallback(
    (newValue) => {
      const normalizedValue = Array.isArray(newValue) ? normalizeRangeValue(newValue) : normalizeRangeValue([newValue]);
      setValue(normalizedValue);
      onSubmit(
        {
          title: `${normalizedValue[0]} - ${normalizedValue[1]}`,
          value: formatRiskScoreFilterValue(normalizedValue)
        },
        true
      );
    },
    [onSubmit]
  );
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    RangeInput,
    {
      id: "risk-score-range-filter",
      label: t("risk_score_filter.label"),
      value,
      min: RISK_SCORE_RANGE.min,
      max: RISK_SCORE_RANGE.max,
      step: 1,
      onChange: handleChange,
      onAfterChange: handleAfterChange
    }
  ), /* @__PURE__ */ React.createElement("p", { className: "help-block" }, t("risk_score_filter.selected_range", { range: formattedValue })));
};
const RiskScoreFilter = ({ filter, onSubmit }) => {
  const initialValue = parseRiskScoreFilterValue(filter == null ? void 0 : filter.value);
  const filterValueKey = formatRiskScoreFilterValue(initialValue);
  return /* @__PURE__ */ React.createElement(RiskScoreFilterContent, { key: filterValueKey, initialValue, onSubmit });
};
export default RiskScoreFilter;
